import { render, staticRenderFns } from "./KimlikBilgisiEkleForm.vue?vue&type=template&id=cb35bee2"
import script from "./KimlikBilgisiEkleForm.vue?vue&type=script&lang=ts"
export * from "./KimlikBilgisiEkleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports